/**
 * School Markers
 * 
 * @Author: Focci
 * @Date: 2023-07-10 10:13:27
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-10 10:13:27
 */

// import PropTypes from 'prop-types'
import SVGSchoolHat from '@img/school-hat.svg'
import clsx from 'clsx'
import { filter } from 'lodash-es'
import { useMapState } from '@comp/mapbox'
import { useMemo } from 'react'
import { useSchoolOptions } from '../controller/overall/useMapboxOverall'
import Markers from './Markers'

export function SchoolMarker({ item }) {
  const schoolOpts = useSchoolOptions()
  const backgroundColor = filter(schoolOpts, (f) => f.value === String(item.schoolTypeId))[0]?.color

  return (
    <div 
      className="
        w-6 h-6 z-20 bg-white flex items-center justify-center
        shadow-large cursor-pointer rounded-full relative
      "
    >
      <SVGSchoolHat />
      {backgroundColor && (
        <span
          className={clsx([
            'absolute top-0 right-0 bg-blue-500 rounded-full',
            'px-1 whitespace-nowrap text-f.7 text-white',
          ])}
          style={{ 
            transform: 'scale(.7) translate(50%, -50%)',
            transformOrigin: '100% 0%',
            backgroundColor
          }}
        >
          {item.schoolTypeLabel}
        </span>
      )}
    </div>
  )
}

export default function SchoolMarkers({
  apiParam,
  ...markerProps
}) {
  const { schoolParam } = useMapState()
  
  const fetchParam = useMemo(() => ({
    rect: apiParam?.rect,
    schoolTypeIds: schoolParam.type.join(',')
  }), [apiParam?.rect, schoolParam.type])

  return (
    <Markers
      url="map/schools"
      type="school"
      marker={SchoolMarker}
      param={fetchParam}
      researchAlwaysOnMove
      {...markerProps}
    />
  )
}

// SchoolMarkers.propTypes = {
//   searchParam: PropTypes.object,
// }
